export type PendingManagementNotice = {
  id: string
  sessionId: string
  title: string
  body: string
  url: string
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/** Validate the server value before allowing it to become an in-app link. */
export function pendingManagementNotice(value: unknown): PendingManagementNotice | null {
  if (!value || typeof value !== 'object') return null
  const item = value as Record<string, unknown>
  const id = typeof item.id === 'string' ? item.id : ''
  const sessionId = typeof item.session_id === 'string' ? item.session_id : ''
  const title = typeof item.title === 'string' ? item.title.trim() : ''
  const body = typeof item.body === 'string' ? item.body.trim() : ''
  const url = typeof item.url === 'string' ? item.url : ''
  if (!UUID.test(id) || !UUID.test(sessionId) || !title || !body || title.length > 160 || body.length > 600) return null
  const expected = `/ai-coding?session=${encodeURIComponent(sessionId)}&management=${encodeURIComponent(id)}`
  if (url !== expected) return null
  return { id, sessionId, title, body, url }
}
